export enum LottieAnimations {
  BackgroundLines = 0,
  Spinner = 1,
  OutroSpinner = 2,
}
